import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  useMediaQuery,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import FormHelperText from "@mui/material/FormHelperText";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import ErrorIcon from "@mui/icons-material/Error";
import ArrowForwardOutlinedIcon from "@mui/icons-material/ArrowForwardOutlined";
import moment from "moment";
//bootstrap input mui
import { styled } from "@mui/material/styles";
import InputBase from "@mui/material/InputBase";
//paper mui
import Typography from "@mui/material/Typography";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import Radio from "@mui/material/Radio";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import "./ToolBox.css";
import { useRef } from "react";
import IconButton from "@mui/material/IconButton";
import { Verified } from "@mui/icons-material";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";

import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { exportToExcel, getStatusStyleV1 } from "../../../Utility/Utilitys";
const BootstrapInput = styled(InputBase)(({ theme, error }) => ({
  "label + &": {
    marginTop: theme.spacing(3),
  },
  "& .MuiInputBase-input": {
    borderRadius: 4,
    position: "relative",
    backgroundColor: "",
    border: "1px solid #ced4da",
    fontSize: 12,
    width: "100",
    padding: "2px 5px",
    transition: theme.transitions.create([
      "border-color",
      "background-color",
      "box-shadow",
    ]),
    border: `1px solid ${error ? "#e74c3c" : "#ced4da"}`,
    // Use the system font instead of the default Roboto font.
    // fontFamily: [
    //     '-apple-system',
    //     'BlinkMacSystemFont',
    //     '"Segoe UI"',
    //     'Roboto',
    //     '"Helvetica Neue"',
    //     'Arial',
    //     'sans-serif',
    //     '"Apple Color Emoji"',
    //     '"Segoe UI Emoji"',
    //     '"Segoe UI Symbol"',
    // ].join(','),
    "&:focus": {
      boxShadow: `unset`,
      borderColor: theme.palette.primary.main,
      borderColor: error ? "#e74c3c" : theme.palette.primary.main,
    },
  },
}));

export const CmpDatePicker = ({
  xLabelText,
  xValue,
  xOnChange,
  xName,
  xError = false,
  xErrorMessage = false,
  xtabIndex = "",
  xref = "",
  xDisable = false,
  xVariant = "outlined",
  xFullWidth = false,
  size = "medium",
  isFoucesd = false,
}) => {
  const fTextFieldDummy = () => {};
  const inputReference = useRef(null);
  return (
    <LocalizationProvider fullWidth dateAdapter={AdapterDayjs}>
      <DatePicker
        disabled={xDisable}
        inputProps={{ tabIndex: xtabIndex }}
        inputRef={xref ? xref : inputReference}
        label={xLabelText}
        rifmFormatter={() => moment(xValue).format("DD/MM/YYYY")}
        inputFormat="DD/MM/YYYY"
        value={xValue}
        onChange={xOnChange}
        // renderInput={(params) => (
        //   <TextField {...params} name={xName} variant={xVariant} />
        // )}
        renderInput={(params) => (
          <TextField
            {...params}
            name={xName}
            // label={xLabelText}
            variant={xVariant}
            fullWidth={xFullWidth}
            size={size}
            focused={isFoucesd}
            error={xError}
            helperText={xErrorMessage}
            sx={{
              width: xFullWidth ? "100%" : "auto",
              height: xFullWidth ? "100%" : "auto", // Ensures full height
              "& .MuiInputBase-root": { height: xFullWidth ? "100%" : "auto" }, // Ensures input field inside has full height
            }}
          />
        )}
        sx={{
          width: xFullWidth ? "100%" : "auto",
          height: xFullWidth ? "100%" : "auto", // Ensures DatePicker takes full height
        }}
      />
    </LocalizationProvider>
  );
};
export const CmpTextField = ({
  xsize = "",
  xTextAlign = "",
  xLabelText = "",
  xVariant = "standard",
  xValue = "",
  xOnChange,
  xReadOnly = false,
  xType = "text",
  xName = "",
  xOnKeyUp,
  xError,
  xErrorMessage,
  xonFocus,
  xonBlur,
  xtabIndex = "",
  xref = "",
  xfontSize,
}) => {
  const fTextFieldDummy = () => {};
  const inputReference = useRef(null);
  return (
    <TextField
      size={xsize}
      inputProps={{ tabIndex: xtabIndex, style: { textAlign: xTextAlign } }}
      inputRef={xref ? xref : inputReference}
      id={xName}
      label={xLabelText}
      variant={xVariant} //"standard/outlined/filled"
      value={xValue}
      type={xType} // text/number/password
      name={xName}
      InputProps={{
        readOnly: xReadOnly,
      }}
      onChange={(e) => {
        xOnChange(e);
      }}
      onKeyUp={!!xOnKeyUp ? xOnKeyUp : fTextFieldDummy}
      onFocus={!!xonFocus ? xonFocus : fTextFieldDummy}
      onBlur={!!xonBlur ? xonBlur : fTextFieldDummy}
      fullWidth
      error={xError}
      fontSize={xfontSize}
      helperText={xErrorMessage}
      autoComplete="off"
    />
  );
};

export const CmpTextFieldEnter = ({
  xLabelText,
  xVariant,
  xValue,
  xOnChange,
  xReadOnly = false,
  xType,
  xName,
  xOnKeyUp,
  xError,
  xErrorMessage,
  xonFocus,
  xonBlur,
  xOnEnter,
  xSmShow,
  xref = "",
  xtabIndex = "",
  xSize = "",
  xId = "",
}) => {
  const fTextFieldDummy = () => {};
  const inputReference = useRef(null);
  return (
    <div className="d-flex TextFieldEnter">
      <TextField
        size={xSize}
        id={xId}
        inputProps={{ tabIndex: xtabIndex }}
        inputRef={xref ? xref : inputReference}
        label={xLabelText}
        variant={xVariant} //"standard/outlined/filled"
        value={xValue}
        type={xType} // text/number/password
        name={xName}
        InputProps={{
          readOnly: xReadOnly,
        }}
        onChange={(e) => {
          xOnChange(e);
        }}
        onKeyUp={!!xOnKeyUp ? xOnKeyUp : fTextFieldDummy}
        onFocus={!!xonFocus ? xonFocus : fTextFieldDummy}
        onBlur={!!xonBlur ? xonBlur : fTextFieldDummy}
        fullWidth
        error={xError}
        helperText={xErrorMessage}
        autoComplete="off"
      />
      {xSmShow ? (
        <>
          <Button
            variant="contained"
            className={xError ? "px-0 enter-btn  mb-4" : "px-0 enter-btn "}
            onClick={!!xOnEnter ? xOnEnter : fTextFieldDummy}
          >
            <ArrowForwardOutlinedIcon />
          </Button>
        </>
      ) : (
        ""
      )}
    </div>
  );
};
export const CmpSelectBox = ({
  xVariant = "outlined",
  xLabelText = "",
  xValue = "",
  xOnChange,
  xName = "",
  xData = [],
  xValueMember = "",
  xDispalyMember = "",
  xError,
  xErrorMessage,
  xDisable = false,
  xref = "",
  xtabIndex = "",
  xsize = "",
  xId = "demo-simple-select",
}) => {
  const inputReference = useRef(null);
  return (
    <FormControl
      fullWidth
      className="LocSelectionStyle"
      disabled={xDisable}
      size={xsize}
    >
      <InputLabel id="demo-simple-select-label">{xLabelText}</InputLabel>
      <Select
        inputProps={{ tabIndex: xtabIndex }}
        inputRef={xref ? xref : inputReference}
        labelId="demo-simple-select-label"
        id={xId} //"demo-simple-select"
        value={xValue}
        label={xLabelText}
        onChange={xOnChange}
        name={xName}
        fullWidth
        variant={xVariant} //"standard/outlined/filled"
        // style={{ height: '2.3rem' }}
        error={xError}
        // helperText={xErrorMessage}
      >
        {xData.length > 0 ? (
          xData.map((e, i) => {
            const keys = Object.keys(e);
            return (
              <MenuItem key={"Key" + i} value={e[keys[0]]}>
                {e[keys[1]]}
              </MenuItem>
            );
          })
        ) : (
          <MenuItem value={""}></MenuItem>
        )}
      </Select>
      {xError ? (
        <FormHelperText className="text-danger">{xErrorMessage}</FormHelperText>
      ) : (
        ""
      )}
    </FormControl>
  );
};

//without label
export const CmpInputField = ({
  xVariant = "",
  xValue,
  xOnChange,
  xReadOnly = false,
  xType = "text",
  xName,
  xOnKeyUp,
  xError = false,
  xErrorMessage = "",
  xonFocus,
  xonBlur,
  xtabIndex = "",
  xref = "",
  xTextAlign = "left",
}) => {
  const fTextFieldDummy = () => {};
  const inputReference = useRef(null);
  return (
    <>
      <BootstrapInput
        disabled={xReadOnly}
        inputProps={{ tabIndex: xtabIndex, style: { textAlign: xTextAlign } }}
        inputRef={xref ? xref : inputReference}
        className={xReadOnly ? "disable-color" : ""}
        value={xValue}
        type={xType} // text/number/password
        name={xName}
        readOnly={xReadOnly}
        onChange={(e) => {
          xOnChange(e);
        }}
        onKeyUp={!!xOnKeyUp ? xOnKeyUp : fTextFieldDummy}
        onFocus={!!xonFocus ? xonFocus : fTextFieldDummy}
        onBlur={!!xonBlur ? xonBlur : fTextFieldDummy}
        fullWidth
        autoComplete="off"
        variant="standard"
      />
      {xError ? (
        <FormHelperText error={xError}>{xErrorMessage}</FormHelperText>
      ) : (
        ""
      )}
    </>
  );
};

export const CmpInputFieldGroup = ({
  xValue,
  xOnChange,
  xReadOnly = false,
  xType,
  xName,
  xOnKeyUp,
  xError,
  xErrorMessage,
  xonFocus,
  xonBlur,
  xtabIndex = "",
  xref = "",
  xTextAlign = "left",
}) => {
  const fTextFieldDummy = () => {};
  const inputReference = useRef(null);
  return (
    <>
      <div className="CmpInputFieldGroup">
        <BootstrapInput
          disabled={xReadOnly}
          inputProps={{ tabIndex: xtabIndex, style: { textAlign: xTextAlign } }}
          inputRef={xref ? xref : inputReference}
          className={xReadOnly ? "disable-color" : ""}
          value={xValue}
          type={xType} // text/number/password
          name={xName}
          readOnly={xReadOnly}
          onChange={(e) => {
            xOnChange(e);
          }}
          error={false}
          onKeyUp={!!xOnKeyUp ? xOnKeyUp : fTextFieldDummy}
          onFocus={!!xonFocus ? xonFocus : fTextFieldDummy}
          onBlur={!!xonBlur ? xonBlur : fTextFieldDummy}
          fullWidth
          autoComplete="off"
        />
        <Button
          variant="outlined"
          className="CmpInputFieldGroup-icon"
          onClick={!!xOnKeyUp ? xOnKeyUp : fTextFieldDummy}
          onKeyUp={!!xOnKeyUp ? xOnKeyUp : fTextFieldDummy}
        >
          <MoreHorizIcon />
        </Button>
      </div>
      {xError ? (
        <FormHelperText error={xError}>{xErrorMessage}</FormHelperText>
      ) : (
        ""
      )}
    </>
  );
};

export const CmpInputFieldGroupV1 = ({
  xValue,
  xOnChange,
  xReadOnly = false,
  xType,
  xName,
  xOnKeyUp,
  xError,
  xErrorMessage,
  xonFocus,
  xonBlur,
  xtabIndex = "",
  xref = "",
  xTextAlign = "left",
}) => {
  const fTextFieldDummy = () => {};
  const inputReference = useRef(null);
  return (
    <>
      <div className="CmpInputFieldGroup">
        <BootstrapInput
          disabled={xReadOnly}
          inputProps={{ tabIndex: xtabIndex, style: { textAlign: xTextAlign } }}
          inputRef={xref ? xref : inputReference}
          className={xReadOnly ? "disable-color" : ""}
          value={xValue}
          type={xType} // text/number/password
          name={xName}
          readOnly={xReadOnly}
          onChange={(e) => {
            xOnChange(e);
          }}
          error={xError}
          onKeyUp={!!xOnKeyUp ? xOnKeyUp : fTextFieldDummy}
          onFocus={!!xonFocus ? xonFocus : fTextFieldDummy}
          onBlur={!!xonBlur ? xonBlur : fTextFieldDummy}
          fullWidth
          autoComplete="off"
        />
        <Button
          variant="outlined"
          className="CmpInputFieldGroup-icon"
          onClick={!!xOnKeyUp ? xOnKeyUp : fTextFieldDummy}
          onKeyUp={!!xOnKeyUp ? xOnKeyUp : fTextFieldDummy}
        >
          <MoreHorizIcon />
        </Button>
      </div>
      {xError ? (
        <FormHelperText error={xError}>{xErrorMessage}</FormHelperText>
      ) : (
        ""
      )}
    </>
  );
};
// arr of obj [{},{}]
export const CmpSelectField = ({
  xLabelText,
  xValue,
  xOnChange = () => {},
  xName,
  xData = [],
  xValueMember = "",
  xDispalyMember = "",
  xError = false,
  xErrorMessage = false,
  xDisable = false,
  xOnkeyUp,
  xtabIndex = "",
  xref = "",
  xonFocus,
  xonBlur,
  salespaddingReduce = false,
}) => {
  const fTextFieldDummy = (e) => {};
  const inputReference = useRef(null);
  return (
    <FormControl fullWidth className="LocSelectionStyle" disabled={xDisable}>
      {/* <InputLabel id="demo-simple-select-label">{xLabelText}</InputLabel> */}
      <Select
        inputProps={{ tabIndex: xDisable ? "" : xtabIndex }}
        inputRef={xref ? xref : inputReference}
        className={
          xDisable
            ? "disable-color test sales-invoice-responsive-select"
            : "test sales-invoice-responsive-select"
        }
        value={!!xValue ? xValue : ""}
        label={xLabelText}
        onChange={!!xOnChange ? xOnChange : fTextFieldDummy}
        onFocus={!!xonFocus ? xonFocus : fTextFieldDummy}
        onBlur={!!xonBlur ? xonBlur : fTextFieldDummy}
        name={xName}
        fullWidth
        onKeyUp={!!xOnkeyUp ? xOnkeyUp : fTextFieldDummy}
        // style={{ height: '2.3rem' }}
        input={<BootstrapInput />}
        // error={xError}

        // helperText={xErrorMessage}
      >
        {xData.length > 0 ? (
          xData?.map((e, i) => {
            const keys = Object.keys(e);
            return (
              <MenuItem key={"Key" + i} value={e[keys[0]]}>
                {e[keys[1]]}
              </MenuItem>
            );
          })
        ) : (
          <MenuItem value={""}>none</MenuItem>
        )}
      </Select>
      {xError ? (
        <FormHelperText className="text-danger">{xErrorMessage}</FormHelperText>
      ) : (
        ""
      )}
    </FormControl>
  );
};

export const CmpSelectFieldV1 = ({
  xLabelText,
  xValue,
  xOnChange = () => {},
  xName,
  xData = [],
  xValueMember = "",
  xDispalyMember = "",
  xError = false,
  xErrorMessage = false,
  xDisable = false,
  xOnkeyUp,
  xtabIndex = "",
  xref = "",
  xonFocus,
  xonBlur,
  salespaddingReduce = false,
}) => {
  const fTextFieldDummy = (e) => {};
  const inputReference = useRef(null);
  return (
    <FormControl fullWidth className="LocSelectionStyle" disabled={xDisable}>
      {/* <InputLabel id="demo-simple-select-label">{xLabelText}</InputLabel> */}
      <Select
        inputProps={{ tabIndex: xDisable ? "" : xtabIndex }}
        inputRef={xref ? xref : inputReference}
        className={
          xDisable
            ? "disable-color test sales-invoice-responsive-select"
            : "test sales-invoice-responsive-select"
        }
        value={!!xValue ? xValue : ""}
        label={xLabelText}
        onChange={!!xOnChange ? xOnChange : fTextFieldDummy}
        onFocus={!!xonFocus ? xonFocus : fTextFieldDummy}
        onBlur={!!xonBlur ? xonBlur : fTextFieldDummy}
        name={xName}
        fullWidth
        onKeyUp={!!xOnkeyUp ? xOnkeyUp : fTextFieldDummy}
        // style={{ height: '2.3rem' }}
        input={<BootstrapInput />}
        error={xError}

        // helperText={xErrorMessage}
      >
        {xData.length > 0 ? (
          xData?.map((e, i) => {
            const keys = Object.keys(e);
            return (
              <MenuItem key={"Key" + i} value={e[keys[0]]}>
                {e[keys[1]]}
              </MenuItem>
            );
          })
        ) : (
          <MenuItem value={""}>none</MenuItem>
        )}
      </Select>
      {xError ? (
        <FormHelperText className="text-danger">{xErrorMessage}</FormHelperText>
      ) : (
        ""
      )}
    </FormControl>
  );
};

//Arr Of value["",""]
export const CmpSelectArrField = ({
  xLabelText,
  xValue,
  xOnChange,
  xName,
  xData = [],
  xValueMember = "",
  xDispalyMember = "",
  xError = false,
  xErrorMessage = false,
  xDisable = false,
  xOnkeyUp,
  xtabIndex = "",
  xref = "",
  xonFocus,
  xonBlur,
}) => {
  const fTextFieldDummy = () => {};
  const inputReference = useRef(null);
  return (
    <FormControl fullWidth className="LocSelectionStyle" disabled={xDisable}>
      {/* <InputLabel id="demo-simple-select-label">{xLabelText}</InputLabel> */}
      <Select
        inputProps={{ tabIndex: xDisable ? "" : xtabIndex }}
        inputRef={xref ? xref : inputReference}
        className={
          xDisable
            ? "disable-color mutiple-select-responsive"
            : "mutiple-select-responsive"
        }
        value={!!xValue ? xValue : ""}
        label={xLabelText}
        onChange={!!xOnChange ? xOnChange : fTextFieldDummy}
        onFocus={!!xonFocus ? xonFocus : fTextFieldDummy}
        onBlur={!!xonBlur ? xonBlur : fTextFieldDummy}
        name={xName}
        fullWidth
        onKeyUp={!!xOnkeyUp ? xOnkeyUp : fTextFieldDummy}
        // style={{ height: '2.3rem' }}
        input={<BootstrapInput />}
        error={xError}
        // sx={{ padding: { md: "2px 5px !important", sm: "0px 5px !important", xs: "0px 5px !important" } }}

        // helperText={xErrorMessage}
      >
        {xData?.length > 0 ? (
          xData?.map((e, i) => {
            return (
              <MenuItem key={"Key" + i} value={e}>
                {e}
              </MenuItem>
            );
          })
        ) : (
          <MenuItem value={""}>none</MenuItem>
        )}
      </Select>
      {xError ? (
        <FormHelperText className="text-danger">{xErrorMessage}</FormHelperText>
      ) : (
        ""
      )}
    </FormControl>
  );
};
export const CmpDatePickerField = ({
  xValue,
  xOnChange,
  xName,
  xError = false,
  xErrorMessage = false,
  xOnKeyUp,
  xtabIndex = "",
  xref = "",
  xmindate = "",
  xDisable = false,
  xmaxdate = "",
}) => {
  const fTextFieldDummy = (e) => {};
  const inputReference = useRef(null);
  return (
    <LocalizationProvider
      dateAdapter={AdapterDayjs}
      className="CmpDatePickerField"
    >
      <DatePicker
        label={""}
        disabled={xDisable}
        // rifmFormatter={() => moment(xValue).format("DD/MM/YYYY")}
        inputFormat="DD/MM/YYYY"
        value={xValue}
        onChange={!!xOnChange ? xOnChange : fTextFieldDummy}
        onKeyUp={!!xOnKeyUp ? xOnKeyUp : fTextFieldDummy}
        inputProps={{
          style: { height: "1.4rem" }, //safia
          // style: { height: '1.4rem' },
          tabIndex: xtabIndex,
        }}
        inputRef={xref ? xref : inputReference}
        renderInput={(params) => <TextField {...params} name={xName} />}
        minDate={xmindate}
        maxDate={xmaxdate}
        // name={xName}
        className="CmpDatePickerField"
        // style={ { height: '1.3rem!important' } }

        // input={<BootstrapInput />}
        // style={{ height: '2.3rem' }}
      />
      {xError ? (
        <FormHelperText className="text-danger">{xErrorMessage}</FormHelperText>
      ) : (
        ""
      )}
    </LocalizationProvider>
  );
};

export const CmpDatePickerField001 = ({
  xValue,
  xOnChange,
  xName,
  xError = false,
  xErrorMessage = false,
  xOnKeyUp,
  xtabIndex = "",
  xref = "",
  xmindate = "",
  xDisable = false,
  xmaxdate = "",
}) => {
  const fTextFieldDummy = (e) => {};
  const inputReference = useRef(null);
  return (
    <LocalizationProvider
      dateAdapter={AdapterDayjs}
      className="CmpDatePickerField-v1"
    >
      <DatePicker
        label={""}
        disabled={xDisable}
        // rifmFormatter={() => moment(xValue).format("DD/MM/YYYY")}
        inputFormat="DD/MM/YYYY"
        value={xValue}
        onChange={!!xOnChange ? xOnChange : fTextFieldDummy}
        onKeyUp={!!xOnKeyUp ? xOnKeyUp : fTextFieldDummy}
        inputProps={{
          // style: { height: '1.4rem' },
          tabIndex: xtabIndex,
        }}
        inputRef={xref ? xref : inputReference}
        renderInput={(params) => <TextField {...params} name={xName} />}
        minDate={xmindate}
        maxDate={xmaxdate}
        // name={xName}
        className="CmpDatePickerField-v1"
        // style={ { height: '1.3rem!important' } }

        // input={<BootstrapInput />}
        // style={{ height: '2.3rem' }}
      />
      {xError ? (
        <FormHelperText className="text-danger">{xErrorMessage}</FormHelperText>
      ) : (
        ""
      )}
    </LocalizationProvider>
  );
};

//In search initial state value will be empty ,so border is red to avoid that this component
export const CmpDatePickerFieldSearch = ({
  xValue,
  xOnChange,
  xName,
  xError = false,
  xErrorMessage = false,
  xOnKeyUp,
  xtabIndex = "",
  xref = "",
  xmindate = "",
  xDisable = false,
  xmaxdate = "",
}) => {
  const fTextFieldDummy = (e) => {};
  const inputReference = useRef(null);
  return (
    <LocalizationProvider
      dateAdapter={AdapterDayjs}
      className="CmpDatePickerField"
    >
      <DatePicker
        label={""}
        disabled={xDisable}
        // rifmFormatter={() => moment(xValue).format("DD/MM/YYYY")}
        inputFormat="DD/MM/YYYY"
        value={xValue}
        onChange={!!xOnChange ? xOnChange : fTextFieldDummy}
        onKeyUp={!!xOnKeyUp ? xOnKeyUp : fTextFieldDummy}
        inputProps={{
          style: { height: "1.4rem" },
          tabIndex: xtabIndex,
        }}
        inputRef={xref ? xref : inputReference}
        renderInput={(params) => <TextField {...params} name={xName} />}
        minDate={xmindate}
        maxDate={xmaxdate}
        // name={xName}
        className="CmpDatePickerField CmpDatePickerFieldSearch"
        // style={ { height: '1.3rem!important' } }

        // input={<BootstrapInput />}
        // style={{ height: '2.3rem' }}
      />
      {xError ? (
        <FormHelperText className="text-danger">{xErrorMessage}</FormHelperText>
      ) : (
        ""
      )}
    </LocalizationProvider>
  );
};

export const CmpTypographyField = ({
  xcomponent,
  xText,
  xfontSize = "14px",
  xtextDecoration = "",
  xMarginTop = "0px",
  xonClick,
}) => {
  const fTextFieldDummy = (e) => {};
  return (
    <div className="txt-overflow-ellipse">
      <Typography
        className="txt-overflow-ellipse typograpgy-font"
        component={xcomponent}
        sx={{
          fontSize: xfontSize,
          textDecoration: xtextDecoration,
          marginTop: xMarginTop,
        }}
        onClick={!!xonClick ? xonClick : fTextFieldDummy}
      >
        {xText}
      </Typography>
    </div>
  );
};

export const CmpExportExcel = ({
  data = [],
  fileName = "",
  sheetName = "",
}) => {
  return (
    <Box className="exportBox">
      <IconButton
        onClick={() => {
          exportToExcel(data, fileName, sheetName);
        }}
      >
        <FileDownloadOutlinedIcon />
      </IconButton>
      <Typography variant="caption" sx={{ mt: -1 }}>
        Export
      </Typography>
    </Box>
  );
};

export const CmpButton = ({
  xbtnName = "",
  xOnClick,
  xVariant = "contained",
  xDisabled = false,
  xSize = "",
  xjustifyContent = "center",
  xId = "",
  xSendIcon = "",
  xendIcon = "",
  xWidth = "",
  xColor = "primary",
}) => {
  const fTextFieldDummy = (e) => {};

  // <CmpButton
  // xbtnName="New"
  // xOnClick=""
  // xVariant="text"
  // xDisabled={false}
  // xSize="small"
  // />
  return (
    <Button
      id={xId}
      onClick={xOnClick ? xOnClick : fTextFieldDummy}
      variant={xVariant}
      disabled={xDisabled}
      size={xSize}
      color={xColor}
      className="btn-min-width btn-nav-font btn-text-transform-none"
      sx={{ justifyContent: xjustifyContent, width: xWidth }}
      // variant="outlined"
      startIcon={xSendIcon}
      endIcon={xendIcon}
    >
      {/* <Tooltip title={xbtnName}>
          
            </Tooltip> */}
      {xbtnName}
    </Button>
  );
};

export const CmpButton001 = ({
  xbtnName = "",
  xOnClick,
  xVariant = "contained",
  xDisabled = false,
  xSize = "small",
  xjustifyContent = "center",
  xId = "",
  xSendIcon = "",
  xendIcon = "",
}) => {
  const fTextFieldDummy = (e) => {};

  // <CmpButton
  // xbtnName="New"
  // xOnClick=""
  // xVariant="text"
  // xDisabled={false}
  // xSize="small"
  // />
  return (
    <Button
      id={xId}
      onClick={xOnClick ? xOnClick : fTextFieldDummy}
      variant={xVariant}
      disabled={xDisabled}
      size={xSize}
      className="btn-min-width btn-nav-font btn-text-transform-none sales-invoice-responsive-btn"
      sx={{ justifyContent: xjustifyContent }}
      // variant="outlined"
      startIcon={xSendIcon}
      endIcon={xendIcon}
    >
      {/* <Tooltip title={xbtnName}>
          
            </Tooltip> */}
      {xbtnName}
    </Button>
  );
};

export const CmpButtonV2 = ({
  xbtnName = "",
  xOnClick,
  xVariant = "contained",
  xDisabled = false,
  xSize = "small",
  xjustifyContent = "center",
  xId = "",
  xSendIcon = "",
  xendIcon = "",
}) => {
  const fTextFieldDummy = (e) => {};
  const vMediaQuery = useMediaQuery("(max-width:450px)");
  const xMediaQuery = useMediaQuery("(max-width:1300px)");
  return (
    <Button
      id={xId}
      onClick={xOnClick ? xOnClick : fTextFieldDummy}
      variant={xVariant}
      disabled={xDisabled}
      size={xSize}
      className="btn-text-transform-none sales-invoice-responsive-btn"
      sx={{
        justifyContent: xjustifyContent,
        padding: vMediaQuery ? "4px 4px" : "4px 10px",
        minWidth: vMediaQuery ? "50px" : xMediaQuery ? "60px" : "70px",
        ...getStatusStyleV1(xbtnName),
        "&:hover": {
          ...getStatusStyleV1(xbtnName),
          opacity: 0.9,
        },
      }}
      // variant="outlined"
      startIcon={xSendIcon}
      endIcon={xendIcon}
    >
      {xbtnName}
    </Button>
  );
};
export const SalesInvoiceCmpButton001 = ({
  xbtnName = "",
  xOnClick,
  xVariant = "contained",
  xDisabled = false,
  xSize = "small",
  xjustifyContent = "center",
  xId = "",
  xSendIcon = "",
  xendIcon = "",
}) => {
  const fTextFieldDummy = (e) => {};

  // <CmpButton
  // xbtnName="New"
  // xOnClick=""
  // xVariant="text"
  // xDisabled={false}
  // xSize="small"
  // />
  return (
    <Button
      id={xId}
      onClick={xOnClick ? xOnClick : fTextFieldDummy}
      variant={xVariant}
      disabled={xDisabled}
      size={xSize}
      className="btn-min-width btn-nav-font001 btn-text-transform-none"
      sx={{ justifyContent: xjustifyContent }}
      // variant="outlined"
      startIcon={xSendIcon}
      endIcon={xendIcon}
    >
      {/* <Tooltip title={xbtnName}>
          
            </Tooltip> */}
      {xbtnName}
    </Button>
  );
};

export const CmpStatusIcon = ({ xStatus, xfontSize = "medium" }) => {
  return (
    <>
      <Verified
        style={{
          color:
            xStatus?.toUpperCase() == "POST" ||
            xStatus?.toUpperCase() == "COMPLETED"
              ? "#198754"
              : xStatus?.toUpperCase() == "ENTER" ||
                xStatus?.toUpperCase() == "PENDING"
              ? "#ffc107"
              : xStatus?.toUpperCase() == "DELETE"
              ? "#dc3545"
              : "#0d73bb",
        }}
        fontSize={xfontSize}
      />
    </>
  );
};

export const CmpStatusIconV1 = ({ xStatus }) => {
  return (
    <>
      <Verified
        style={{
          color:
            xStatus?.toUpperCase() == "POST" ||
            xStatus?.toUpperCase() == "COMPLETED"
              ? "#198754"
              : xStatus?.toUpperCase() == "ENTER" ||
                xStatus?.toUpperCase() == "PENDING"
              ? "#ffc107"
              : xStatus?.toUpperCase() == "DELETE"
              ? "#dc3545"
              : "#0d73bb",
        }}
        fontSize="small"
      />
    </>
  );
};
export const CmpStatusIconV2 = ({ xStatus }) => {
  return (
    <>
      <ErrorIcon
        style={{
          color:
            xStatus?.toUpperCase() == "POST" ||
            xStatus?.toUpperCase() == "COMPLETED"
              ? "#198754"
              : xStatus?.toUpperCase() == "ENTER" ||
                xStatus?.toUpperCase() == "PENDING"
              ? "#ffc107"
              : xStatus?.toUpperCase() == "DELETE"
              ? "#dc3545"
              : "#0d73bb",
        }}
        fontSize="small"
      />
    </>
  );
};
export const CmpStatusIconV3 = ({ xStatus }) => {
  return (
    <>
      <FiberManualRecordIcon
        style={{
          color:
            Number(xStatus) == 3
              ? "#198754" //green
              : Number(xStatus) == 1
              ? "#ffc107" // yellow
              : Number(xStatus) == 2
              ? "#dc3545" //red
              : "#0d73bb",
        }}
        fontSize="medium"
      />
    </>
  );
};

export const CmpStatusIconV4 = ({ xStatus, NumberId }) => {
  const bgColor =
    Number(xStatus) === 3
      ? "#198754" // Green
      : Number(xStatus) === 1
      ? "#ffc107" // Yellow
      : Number(xStatus) === 2
      ? "#dc3545" // Red
      : "#0d73bb"; // Default Blue

  return (
    <Box
      sx={{
        width: 32,
        height: 32,
        borderRadius: "50%",
        backgroundColor: bgColor,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#fff",
        fontWeight: "bolder",
        fontSize: "12px",
      }}
    >
      <Typography variant="body2" fontWeight="bold">
        {NumberId}
      </Typography>
    </Box>
  );
};

export const CmpStatus = ({
  xStatus,
  xId = "WMSDocStatID",
  xStatusName = "STATUS =",
}) => {
  return (
    <button
      className={
        xStatus === "ENTER"
          ? "btn px-4 status-btn-top-bottom-space-respons-view py-0 btn-warning"
          : xStatus === "POST"
          ? "btn px-4 status-btn-top-bottom-space-respons-view py-0 btn-success"
          : xStatus === "DELETE"
          ? "btn px-4  status-btn-top-bottom-space-respons-view py-0 btn-danger"
          : xStatus === "DRAFT"
          ? "btn px-4  status-btn-top-bottom-space-respons-view py-0 btn-secondary"
          : "btn px-4  status-btn-top-bottom-space-respons-view py-0 btn-primary"
      }
    >
      <span> {xStatusName}</span>
      <span id="">{xStatus}</span>
    </button>
  );
};

export const CmpButtonKIcon = ({
  xOnClick,
  xDisabled = false,
  xSize = "small",
  xIcon = "",
  xcolor = "primary",
}) => {
  const fTextFieldDummy = (e) => {};
  // <CmpButton
  //     xOnClick=""
  //     xDisabled={false}
  //     xIcon={<DeleteIcon fontSize={"small"} />}
  // />
  return (
    <IconButton
      onClick={xOnClick ? xOnClick : fTextFieldDummy}
      disabled={xDisabled}
      size={xSize}
      color={xcolor}
    >
      {xIcon}
    </IconButton>
  );
};
export const CmpButtonKWithIcon = ({
  xOnClick,
  xDisabled = false,
  xSize = "medium",
  xIcon = "",
  xcolor = "primary",
}) => {
  const fTextFieldDummy = (e) => {};

  return (
    <Button
      variant="outlined"
      style={{
        //    display: "flex",
        //    alignItems: "center",
        //    justifyContent: "center",
        //    padding:"0",
        minWidth: "50px",
      }}
      onClick={xOnClick ? xOnClick : fTextFieldDummy}
      disabled={xDisabled}
      size={xSize}
      color={xcolor}
    >
      {xIcon}
    </Button>
  );
};

export const CmpCheckboxField = ({
  xChecked,
  xOnChange,
  xDisabled,
  xName,
  xNameField,
  xOnkeyUp,
  xtabIndex = "",
  xref = "",
  xError = false,
  xErrorMessage = "",
  sales_onvoice_check_box = "center",
  xlabelPlacement = "end",
}) => {
  const fTextFieldDummy = () => {};
  const inputReference = useRef(null);
  return (
    <>
      <FormGroup className="CmpCheckboxField txt-overflow-ellipse">
        <FormControlLabel
          sx={{
            marginRight: "0px",
            textAlign: "center",
            display: "flex",
            justifyContent: sales_onvoice_check_box,
            alignItems: "center",
          }}
          control={
            <Checkbox
              className="d-flex align-items-center justify-content-center foc-text-server-responsive"
              checked={xChecked}
              onChange={!!xOnChange ? xOnChange : fTextFieldDummy}
              onKeyUp={!!xOnkeyUp ? xOnkeyUp : fTextFieldDummy}
              inputProps={{ tabIndex: xtabIndex }}
              inputRef={xref ? xref : inputReference}
            />
          }
          name={xName}
          label={xNameField}
          disabled={xDisabled}
          labelPlacement={xlabelPlacement}
        />
      </FormGroup>
      {xError ? (
        <FormHelperText className="danger">{xErrorMessage}</FormHelperText>
      ) : (
        ""
      )}
    </>
  );
};
export const CmpCheckboxFieldIndeterminate = ({
  xChecked,
  xCheckedIndeterminate,
  xOnChange,
  xDisabled,
  xName,
  xNameField,
  xOnkeyUp,
  xtabIndex = "",
  xref = "",
  xError = false,
  xErrorMessage = "",
}) => {
  const fTextFieldDummy = () => {};
  const inputReference = useRef(null);
  return (
    <>
      <FormGroup className="CmpCheckboxField txt-overflow-ellipse">
        <FormControlLabel
          className="text-center me-0"
          control={
            <Checkbox
              checked={xChecked}
              onChange={!!xOnChange ? xOnChange : fTextFieldDummy}
              onKeyUp={!!xOnkeyUp ? xOnkeyUp : fTextFieldDummy}
              inputProps={{ tabIndex: xtabIndex }}
              inputRef={xref ? xref : inputReference}
              indeterminate={xCheckedIndeterminate}
            />
          }
          name={xName}
          label={xNameField}
          disabled={xDisabled}
        />
      </FormGroup>
      {xError ? (
        <FormHelperText className="danger">{xErrorMessage}</FormHelperText>
      ) : (
        ""
      )}
    </>
  );
};

export const CmpRadioField = ({
  xOnkeyUp,
  xChecked,
  xOnChange,
  xValue,
  xName,
  xNameField,
  xtabIndex = "",
  xref = "",
}) => {
  const fTextFieldDummy = () => {};
  const inputReference = useRef(null);
  return (
    <>
      <Radio
        inputProps={{ tabIndex: xtabIndex }}
        inputRef={xref ? xref : inputReference}
        onKeyUp={!!xOnkeyUp ? xOnkeyUp : fTextFieldDummy}
        checked={xChecked}
        onChange={!!xOnChange ? xOnChange : fTextFieldDummy}
        value={xValue}
        name={xName}
      />

      {xNameField === "" ? "" : xNameField}
    </>
  );
};
export const CmpTextFieldGroup = ({
  xLabelText,
  xVariant,
  xValue,
  xOnChange,
  xReadOnly = false,
  xType,
  xName,
  xOnKeyUp,
  xError,
  xErrorMessage,
  xonFocus,
  xonBlur,
  xOnEnter,
  xSmShow,
  xref = "",
  xtabIndex = "",
  xOnClick,
  xDisabled = false,
  xSize = "small",
  xIcon = "",
  xcolor = "primary",
}) => {
  const fTextFieldDummy = () => {};
  const inputReference = useRef(null);

  return (
    <div className="d-flex">
      <TextField
        // id={xName}
        inputProps={{ tabIndex: xtabIndex }}
        inputRef={xref ? xref : inputReference}
        label={xLabelText}
        variant={xVariant} //"standard/outlined/filled"
        value={xValue}
        type={xType} // text/number/password
        name={xName}
        InputProps={{
          readOnly: xReadOnly,
        }}
        onChange={(e) => {
          xOnChange(e);
        }}
        onKeyUp={!!xOnKeyUp ? xOnKeyUp : fTextFieldDummy}
        onFocus={!!xonFocus ? xonFocus : fTextFieldDummy}
        onBlur={!!xonBlur ? xonBlur : fTextFieldDummy}
        fullWidth
        error={xError}
        helperText={xErrorMessage}
        autoComplete="off"
      />
      <IconButton
        onClick={xOnClick ? xOnClick : fTextFieldDummy}
        disabled={xDisabled}
        size={xSize}
        color={xcolor}
      >
        {xIcon}
      </IconButton>
    </div>
  );
};

export const CmpRadioButton = ({
  value,
  label,
  checked,
  onChange,
  xDisabled = false,
}) => {
  return (
    <FormControlLabel
      value={value}
      control={<Radio />}
      label={label}
      name={label}
      checked={checked}
      onChange={onChange}
      disabled={xDisabled}
    />
  );
};

export const CmpTypographyNew = ({ xcomponent, xText, xVariant = "body1" }) => {
  const vMediaQuery = useMediaQuery("(max-width:450px)");
  return (
    <div className="txt-overflow-ellipse">
      <Typography
        variant={xVariant}
        component={xcomponent}
        sx={{
          fontSize: vMediaQuery ? "12px" : "14px",
          marginTop: vMediaQuery ? "0px" : "5px",
        }}
      >
        {xText}
      </Typography>
    </div>
  );
};
